var map = {
	"./_th/address.json": 61530,
	"./_th/billing-info.json": 84286,
	"./_th/common.json": 87159,
	"./_th/customer-info.json": 88171,
	"./_th/delivery-info.json": 72895,
	"./_th/excluded-countries.json": 67600,
	"./_th/home.json": 47193,
	"./_th/institution.json": 46054,
	"./_th/issuepolicy.json": 53569,
	"./_th/policy-holder.json": 29203,
	"./_th/quotation.json": 67839,
	"./_th/quote-summary.json": 57988,
	"./_th/search.json": 33811,
	"./_th/toast.json": 78956,
	"./en/address.json": 10610,
	"./en/billing-info.json": 23629,
	"./en/common.json": 27008,
	"./en/customer-info.json": 6540,
	"./en/delivery-info.json": 28020,
	"./en/excluded-countries.json": 89661,
	"./en/home.json": 66602,
	"./en/institution.json": 72955,
	"./en/issuepolicy.json": 92962,
	"./en/policy-holder.json": 22800,
	"./en/quotation.json": 99774,
	"./en/quote-summary.json": 89445,
	"./en/search.json": 48767,
	"./en/toast.json": 7428,
	"src/assets/i18n/_th/address.json": 61530,
	"src/assets/i18n/_th/billing-info.json": 84286,
	"src/assets/i18n/_th/common.json": 87159,
	"src/assets/i18n/_th/customer-info.json": 88171,
	"src/assets/i18n/_th/delivery-info.json": 72895,
	"src/assets/i18n/_th/excluded-countries.json": 67600,
	"src/assets/i18n/_th/home.json": 47193,
	"src/assets/i18n/_th/institution.json": 46054,
	"src/assets/i18n/_th/issuepolicy.json": 53569,
	"src/assets/i18n/_th/policy-holder.json": 29203,
	"src/assets/i18n/_th/quotation.json": 67839,
	"src/assets/i18n/_th/quote-summary.json": 57988,
	"src/assets/i18n/_th/search.json": 33811,
	"src/assets/i18n/_th/toast.json": 78956,
	"src/assets/i18n/en/address.json": 10610,
	"src/assets/i18n/en/billing-info.json": 23629,
	"src/assets/i18n/en/common.json": 27008,
	"src/assets/i18n/en/customer-info.json": 6540,
	"src/assets/i18n/en/delivery-info.json": 28020,
	"src/assets/i18n/en/excluded-countries.json": 89661,
	"src/assets/i18n/en/home.json": 66602,
	"src/assets/i18n/en/institution.json": 72955,
	"src/assets/i18n/en/issuepolicy.json": 92962,
	"src/assets/i18n/en/policy-holder.json": 22800,
	"src/assets/i18n/en/quotation.json": 99774,
	"src/assets/i18n/en/quote-summary.json": 89445,
	"src/assets/i18n/en/search.json": 48767,
	"src/assets/i18n/en/toast.json": 7428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20797;